import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControlLabel,
  Radio,
  RadioGroup as MaterialRadioGroup
} from '@material-ui/core';
import { Field } from 'redux-form';

import { onClickWrapper } from '../../../utils/ui';

const RadioGroup = class RadioGroup extends React.Component {
  static renderRadioGroup = ({
    onChange,
    value,
    options,
    className,
    radioClassName,
    radioLabelClassName,
    radioIconClassName,
    radioIconCheckedClassName,
    input
  }) => (
    <MaterialRadioGroup
      className={className}
      value={input ? input.value : value}
      onChange={onClickWrapper(null, input ? input.onChange : onChange)}
    >
      {options.map(
        ({ label, id, value: optionValue, content, testLabelRole }, idx) => (
          <React.Fragment key={idx}>
            <FormControlLabel
              className={radioClassName}
              classes={{ label: radioLabelClassName }}
              label={label}
              value={optionValue}
              control={
                <Radio
                  classes={{
                    root: radioIconClassName,
                    checked: radioIconCheckedClassName
                  }}
                  id={id}
                />
              }
              data-label-role={testLabelRole}
            />
            {value === optionValue && content}
          </React.Fragment>
        )
      )}
    </MaterialRadioGroup>
  );

  render() {
    const {
      name,
      onChange,
      value,
      options,
      className,
      radioClassName,
      radioLabelClassName,
      radioIconClassName,
      radioIconCheckedClassName
    } = this.props;

    const customProps = {
      onChange,
      value,
      options,
      className,
      radioClassName,
      radioLabelClassName,
      radioIconClassName,
      radioIconCheckedClassName
    };
    return name ? (
      <Field
        component={RadioGroup.renderRadioGroup}
        name={name}
        onChange={onChange}
        props={customProps}
      />
    ) : (
      RadioGroup.renderRadioGroup(customProps)
    );
  }
};

RadioGroup.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  options: PropTypes.array,
  className: PropTypes.string,
  radioClassName: PropTypes.string,
  radioLabelClassName: PropTypes.string,
  radioIconClassName: PropTypes.string,
  radioIconCheckedClassName: PropTypes.string
};

export default RadioGroup;
